// Регистр в исходном тексте определяет регистр результата:
// "IYMCS" / "iymcs" → строчными; "Iymcs" (с большой первой буквы) → с большой первой буквы.
const IYMCS_WORD = /\b[Ii][Yy][Mm][Cc][Ss]\b/g;
const isCapitalized = (word) => /^[A-Z][a-z]+$/.test(word);

function markupFor(capitalize) {
  return `${capitalize ? 'Iy' : 'iy'}<span class="iymcs-mcs">mcs</span>`;
}

// Заменяет слово IYMCS/iymcs/Iymcs в тексте (уже отрендеренном HTML) на фирменное
// написание строчными буквами с подчёркнутыми последними тремя буквами (см. IymcsMark.jsx).
// Работает по текстовым узлам DOM, а не строковым replace() —
// чтобы случайно не сломать разметку, если "IYMCS" встретится внутри атрибута (alt, href и т.п.).
export function injectIymcsMark(html) {
  if (!html || typeof document === 'undefined') return html;
  IYMCS_WORD.lastIndex = 0;
  if (!IYMCS_WORD.test(html)) return html;

  const container = document.createElement('div');
  container.innerHTML = html;

  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  let node;
  while ((node = walker.nextNode())) {
    IYMCS_WORD.lastIndex = 0;
    if (IYMCS_WORD.test(node.nodeValue)) textNodes.push(node);
  }

  textNodes.forEach(textNode => {
    const value = textNode.nodeValue;
    const regex = new RegExp(IYMCS_WORD.source, 'g');
    const frag = document.createDocumentFragment();
    let lastIndex = 0;
    let match;
    let found = false;
    while ((match = regex.exec(value))) {
      found = true;
      if (match.index > lastIndex) frag.appendChild(document.createTextNode(value.slice(lastIndex, match.index)));
      const mark = document.createElement('span');
      mark.className = 'iymcs-wordmark';
      mark.innerHTML = markupFor(isCapitalized(match[0]));
      frag.appendChild(mark);
      lastIndex = match.index + match[0].length;
    }
    if (!found) return;
    if (lastIndex < value.length) frag.appendChild(document.createTextNode(value.slice(lastIndex)));
    textNode.parentNode.replaceChild(frag, textNode);
  });

  return container.innerHTML;
}
